import React, { useState, useEffect, useContext, useCallback } from "react";
import useAxios from "../../services/useAxios";
import AuthenticationContext from "../Authentication/AuthenticationContext";
import useSnackBar from "../../components/kits/SnackBar/useSnackBar";
import ColorSchema from "../../assets/kits/colors";
import useWindowSize from "../../hooks/useWindowSize";

type itemType = {
  items: productType[];
  supplier_info: supplierData;
  user_Address: {}[];
};
type supplierData = {
  suppliers__id: number | string;
  title: string;
};
type productType = {
  apo_info: { avb_product_for_order__id: number | string };
  product_info: {};
  current_count: number | string;
  cartitems__id: number | string;
};
type ContextType = {
  shoppingList: itemType[];
  shopCount: number;
  getItemsShop: (shopId: string | number) => void;
  getItemCountPerShop: (shopId: string | number) => void;
  updateShoppingList: () => void;
  changeShoppingCartItemCount: () => void;
  shoppingListItemsFinalState: {};
};

const ShoppingCartItemContext = React.createContext<ContextType>({
  shoppingList: [],
  shopCount: 0,
  getItemsShop: (shopId) => {},
  getItemCountPerShop: (shopId) => {},
  updateShoppingList: () => {},
  changeShoppingCartItemCount: () => {},
  shoppingListItemsFinalState: {},
});

export default ShoppingCartItemContext;

export const ShoppingCartItemProvider: React.FC<{
  children: JSX.Element | JSX.Element[];
}> = ({ children }) => {
  const [shoppingList, setShoppingList] = useState<itemType[]>([]);
  const [shopCount, setShopCount] = useState(0);
  const [shoppingListUpdater, setShoppingListUpdater] = useState(false);
  const [errorTxt, setErrorTxt] = useState("error");
  const { userInfo } = useContext(AuthenticationContext);
  const { execute: getShoppingListApi } = useAxios("api/getcartitems");
  const { execute: addCartItem } = useAxios("api/addcartitem");
  const { execute: reduceCartItem } = useAxios("api/reducecartitems");
  const { width = 0, height } = useWindowSize();
  const [shoppingListItemsState, setShoppingListItemsState] = useState<{
    [key: string]: boolean;
  }>({});
  const [shoppingListItemsFinalState, setShoppingListItemsFinalState] =
    useState<{
      [key: string]: boolean;
    }>({});
  const [trigger, Component] = useSnackBar({
    time: 30,
    className: "txt-t1-m",
    text: errorTxt,
    style: {
      bottom: 20,
      position: "fixed",
      zIndex: 100000,
      color: ColorSchema.foreground_background_me,
      backgroundColor: ColorSchema.schema_surface_light,
      borderColor: ColorSchema.foreground_surface_disable,
      width: width > 600 ? 500 : 335,
      margin:
        width > 600 ? `0 ${(width - 500) / 2}px` : `0 ${(width - 335) / 2}px`,
    },
  });
  const getShoppingListFunc = () => {
    getShoppingListApi().then((data) => {
      let temp = [];
      let itemList = data.data;
      for (let i = 0; i < itemList.length; i++) {
        let tempObject = {
          supplier_info: { suppliers__id: "", title: "" },
          items: [
            {
              apo_info: { avb_product_for_order__id: "" },
              product_info: {},
              current_count: 0,
              cartitems__id: "",
            },
          ],
          user_Address: [],
        };
        let check = temp.find(
          (t) =>
            t?.supplier_info?.suppliers__id ==
            itemList[i].supplier_info.suppliers__id
        );
        if (!check) {
          tempObject = {
            supplier_info: itemList[i].supplier_info,
            items: [
              {
                apo_info: itemList[i].apo_info,
                product_info: itemList[i].product_info,
                current_count: itemList[i].current_count,
                cartitems__id: itemList[i].cartitems__id,
              },
            ],
            user_Address: itemList[i].user_address,
          };
          temp.push(tempObject);
        } else {
          check.items.push({
            apo_info: itemList[i].apo_info,
            product_info: itemList[i].product_info,
            current_count: itemList[i].current_count,
            cartitems__id: itemList[i].cartitems__id,
          });
        }
      }
      setShoppingList(temp);
      setShopCount(temp.length);

      setShoppingListItemsFinalState({});

      // const x = Object.keys(shoppingListItemsState)
      //   .filter((key) => shoppingListItemsState[key] === true)
      //   .reduce((total, key) => ({ ...total, [key]: true }), {});

      // setShopCount(itemList.length);
    });
  };

  const addCartItemFunc = (enterStep = "1", enterPrice = "", enterApo = "") => {
    async function add() {
      await addCartItem({
        count: enterStep,
        price: enterPrice,
        productForOrderId: enterApo,
      }).then((data) => {
        if (data.status == 1) {
          updateShoppingList();
          stateCartItemHandler(`${enterApo}`, false);
        } else stateCartItemHandler(`${enterApo}`, false);
      });
    }
    add();
  };
  const reduceCartItemFunc = (enterApo = "") => {
    reduceCartItem({ productForOrderId: enterApo }).then((data) => {
      if (data.status == 1) {
        updateShoppingList();
        stateCartItemHandler(`${enterApo}`, false);
      } else {
        stateCartItemHandler(`${enterApo}`, false);
      }
    });
  };
  const getItemsShop = useCallback(
    (shopId: Number | string) => {
      let temp = shoppingList.find(
        (v) => v.supplier_info?.suppliers__id == shopId
      );
      return temp ? temp : {};
    },
    [shoppingList]
  );
  const getItemCountPerShop = useCallback(
    (shopId: Number | string) => {
      let object = {};
      let temp = shoppingList.find(
        (v) => v.supplier_info?.suppliers__id == shopId
      );
      if (typeof temp !== "undefined") {
        for (let i = 0; i < temp?.items?.length; i++) {
          object = {
            ...object,
            [`apoId_${temp?.items[i].apo_info.avb_product_for_order__id}`]:
              temp?.items[i].current_count,
          };
        }
      }
      return object;
    },
    [shoppingList]
  );
  const updateShoppingList = () => {
    setShoppingListUpdater((prev) => !prev);
  };
  const changeShoppingCartItemCount = (
    type: string = "",
    max: Number | string = "",
    inventory: string = "",
    min: Number | string = "",
    count: string = "",
    step: string = "1",
    price: string = "",
    apo: string = "",
    pTitle: string = "",
    shopId: string = ""
  ) => {
    if (type === "add") {
      stateCartItemHandler(`${apo}`, true);
      FinalStateCartItemHandler(`${apo}`, true);
      // let shopDataShoppingList = shoppingList.find(
      //   (s) => s.supplier_info.suppliers__id == shopId
      // );
      // if (shopDataShoppingList != undefined || shoppingList.length == 0) {
      if (parseInt(count) >= parseInt(inventory)) {
        trigger();
        setErrorTxt(
          `ظرفیت انتخاب «${pTitle}» ${inventory} عدد می‌باشد و نمی‌توانید بیشتر از ${inventory} عدد انتخاب کنید.`
        );
        stateCartItemHandler(`${apo}`, false);
      } else if (parseInt(count) < parseInt(inventory) || count == "") {
        addCartItemFunc(step, price, apo);
      }
      // } else {
      //   console.log("warning", "محصولی از فروشگاه دیگر در سبد خرید موجود است.");
      // }
    } else if (type === "reduce") {
      stateCartItemHandler(`${apo}`, true);
      FinalStateCartItemHandler(`${apo}`, true);
      reduceCartItemFunc(apo);
    }
  };
  const stateCartItemHandler = (apfoId: string | number, status: boolean) => {
    setShoppingListItemsState((prev) => {
      return { ...prev, [`state-${apfoId}`]: status };
    });
  };
  const FinalStateCartItemHandler = (
    apfoId: string | number,
    status: boolean
  ) => {
    setShoppingListItemsFinalState((prev) => {
      return { ...prev, [`state-${apfoId}`]: status };
    });
  };
  useEffect(() => {
    if (
      Object.keys(shoppingListItemsState).filter(
        (key) => shoppingListItemsState[key] === true
      ).length == 0
    ) {
      getShoppingListFunc();
    }
  }, [shoppingListUpdater, shoppingListItemsState, userInfo.token]);

  return (
    <ShoppingCartItemContext.Provider
      value={{
        shoppingList,
        shopCount,
        getItemsShop,
        getItemCountPerShop,
        updateShoppingList,
        changeShoppingCartItemCount,
        shoppingListItemsFinalState,
      }}
    >
      {children}
      {Component}
    </ShoppingCartItemContext.Provider>
  );
};
